import { defineStore } from "pinia";
import { markRaw, ref, shallowRef } from "vue";

const DEFAULT_OPTIONS = {
	fullscreen: false,
	transition: "dialog-bottom-transition",
	persistent: true,
	scrollable: true,
	maxWidth: null,
	title: "",
	showHeader: true,
};

export const useModalStore = defineStore("modal", () => {
	const isOpen = ref(false);
	const component = shallowRef(null);
	const props = ref({});
	const options = ref({ ...DEFAULT_OPTIONS });

	function open(modalComponent, modalProps = {}, modalOptions = {}) {
		component.value = modalComponent ? markRaw(modalComponent) : null;
		props.value = modalProps;
		options.value = { ...DEFAULT_OPTIONS, ...modalOptions };
		isOpen.value = true;
	}

	function close() {
		isOpen.value = false;
	}

	function clear() {
		component.value = null;
		props.value = {};
		options.value = { ...DEFAULT_OPTIONS };
	}

	return {
		isOpen,
		component,
		props,
		options,
		open,
		close,
		clear,
	};
});
